import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Tabs from "../../../../Components/Tabs";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Pagination from "../../../../Core/Pagination/Pagination";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ExportCSV from "../../../../Core/Export/ExportCSV";
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import useScreenHeight from "../../../../utils/useScreenHeight";

const inspectionSeedData = [
    {
        id: "QI-0001",
        serialNo: "MAT-QA-2025-0001",
        company: "M&T Glass Works",
        inspectionType: "Incoming",
        salesPerson: "Mark Jensen",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:05:00",
        status: "Draft"
    },
    {
        id: "QI-0002",
        serialNo: "MAT-QA-2025-0002",
        company: "M&T Glass Works",
        inspectionType: "Outgoing",
        salesPerson: "Mila Patel",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:06:45",
        status: "Submitted"
    },
    {
        id: "QI-0003",
        serialNo: "MAT-QA-2025-0003",
        company: "M&T Glass Works",
        inspectionType: "Incoming",
        salesPerson: "Mila Patel",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:08:10",
        status: "Submitted"
    },
    {
        id: "QI-0004",
        serialNo: "MAT-QA-2025-0004",
        company: "M&T Glass Works",
        inspectionType: "Outgoing",
        salesPerson: "Mark Jensen",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:09:30",
        status: "Draft"
    },
    {
        id: "QI-0005",
        serialNo: "MAT-QA-2025-0005",
        company: "M&T Glass Works",
        inspectionType: "In Process",
        salesPerson: "Nina Bose",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:10:55",
        status: "Submitted"
    },
    {
        id: "QI-0006",
        serialNo: "MAT-QA-2025-0006",
        company: "M&T Glass Works",
        inspectionType: "In Process",
        salesPerson: "Nina Bose",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:12:18",
        status: "Draft"
    },
    {
        id: "QI-0007",
        serialNo: "MAT-QA-2025-0007",
        company: "M&T Glass Works",
        inspectionType: "Incoming",
        salesPerson: "Samuel Reed",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:13:20",
        status: "Draft"
    },
    {
        id: "QI-0008",
        serialNo: "MAT-QA-2025-0008",
        company: "M&T Glass Works",
        inspectionType: "Incoming",
        salesPerson: "Samuel Reed",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:14:33",
        status: "Cancelled"
    },
    {
        id: "QI-0009",
        serialNo: "MAT-QA-2025-0009",
        company: "M&T Glass Works",
        inspectionType: "Outgoing",
        salesPerson: "Mila Patel",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:15:44",
        status: "Submitted"
    },
    {
        id: "QI-0010",
        serialNo: "MAT-QA-2025-0010",
        company: "M&T Glass Works",
        inspectionType: "In Process",
        salesPerson: "Mark Jensen",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:17:10",
        status: "Cancelled"
    },
    {
        id: "QI-0011",
        serialNo: "MAT-QA-2025-0011",
        company: "M&T Glass Works",
        inspectionType: "Incoming",
        salesPerson: "Samuel Reed",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:18:25",
        status: "Draft"
    },
    {
        id: "QI-0012",
        serialNo: "MAT-QA-2025-0012",
        company: "M&T Glass Works",
        inspectionType: "Incoming",
        salesPerson: "Nina Bose",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:19:55",
        status: "Cancelled"
    },
    {
        id: "QI-0012",
        serialNo: "MAT-QA-2025-0012",
        company: "M&T Glass Works",
        inspectionType: "Incoming",
        salesPerson: "Nina Bose",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:19:55",
        status: "Cancelled"
    },{
        id: "QI-0012",
        serialNo: "MAT-QA-2025-0012",
        company: "M&T Glass Works",
        inspectionType: "Incoming",
        salesPerson: "Nina Bose",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:19:55",
        status: "Cancelled"
    },{
        id: "QI-0012",
        serialNo: "MAT-QA-2025-0012",
        company: "M&T Glass Works",
        inspectionType: "Incoming",
        salesPerson: "Nina Bose",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:19:55",
        status: "Cancelled"
    },{
        id: "QI-0012",
        serialNo: "MAT-QA-2025-0012",
        company: "M&T Glass Works",
        inspectionType: "Incoming",
        salesPerson: "Nina Bose",
        reportDate: "2025-07-03",
        dateTime: "2025-07-03T10:19:55",
        status: "Cancelled"
    }
];

const statusColors = {
    draft: "#6366F1",
    submitted: "#0E7490",
    cancelled: "#EF4444"
};

const Maincontent = () => {
    const navigate = useNavigate();
    const { pageSize } = useScreenHeight();
    const [currentPage, setCurrentPage] = useState(1);
    const [filters, setFilters] = useState({});
    const [showFilters, setShowFilters] = useState(false);
    const [showColumns, setShowColumns] = useState(false);
    const [showExport, setShowExport] = useState(false);
    const [inspections] = useState(inspectionSeedData);
    const [columnsConfig, setColumnsConfig] = useState([
        {
            header: "S. No.",
            accessor: "siNo",
            name: "siNo",
            width: "6%",
            sortable: false,
            visible: true,
            cellRenderer: (row) => row.siNo
        },
        {
            header: "Serial No.",
            accessor: "serialNo",
            name: "Serial No.",
            width: "15%",
            sortable: true,
            visible: true
        },
        {
            header: "Company",
            accessor: "company",
            name: "Company",
            width: "15%",
            sortable: true,
            visible: true
        },
        {
            header: "Inspection Type",
            accessor: "inspectionType",
            name: "Inspection Type",
            width: "12%",
            sortable: true,
            visible: true
        },
        {
            header: "Sales Person",
            accessor: "salesPerson",
            name: "Sales Person",
            width: "12%",
            sortable: true,
            visible: true
        },
        {
            header: "Report Date",
            accessor: "reportDate",
            name: "Report Date",
            width: "12%",
            sortable: true,
            visible: true,
            cellRenderer: (row) => new Date(row.reportDate).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric"
            })
        },
        {
            header: "Date & Time",
            accessor: "dateTime",
            name: "Date & Time",
            width: "15%",
            sortable: true,
            visible: true,
            cellRenderer: (row) => new Date(row.dateTime).toLocaleString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            })
        },
        {
            header: "Status",
            accessor: "status",
            name: "Status",
            width: "12%",
            sortable: true,
            visible: true,
            cellRenderer: (row) => {
                const color = statusColors[row.status?.toLowerCase()] || "#4B5563";
                return (
                    <span
                        style={{
                            backgroundColor: `${color}1A`,
                            color,
                            padding: "4px 12px",
                            borderRadius: 999,
                            fontSize: "12px",
                            fontWeight: 500,
                            textTransform: "capitalize"
                        }}
                    >
                        {row.status?.toLowerCase()}
                    </span>
                );
            }
        },
        {
            header: "Actions",
            accessor: "action",
            name: "Actions",
            width: "8%",
            sortable: false,
            visible: true,
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    id={row.id}
                    onView={() => handleView(row.id)}
                    onEdit={() => handleEdit(row.id)}
                    onDelete={() => handleDelete(row.id)}
                />
            )
        }
    ]);

    const filtersConfig = [
        { name: "serialNo", label: "Serial No.", type: "text", width: "18%" },
        { name: "company", label: "Company", type: "text", width: "18%" },
        {
            name: "inspectionType",
            label: "Inspection Type",
            type: "select",
            width: "18%",
            options: [
                { value: "Incoming", label: "Incoming" },
                { value: "Outgoing", label: "Outgoing" },
                { value: "In Process", label: "In Process" }
            ]
        },
        { name: "salesPerson", label: "Sales Person", type: "text", width: "18%" },
        {
            name: "status",
            label: "Status",
            type: "select",
            width: "18%",
            options: [
                { value: "Draft", label: "Draft" },
                { value: "Submitted", label: "Submitted" },
                { value: "Cancelled", label: "Cancelled" }
            ]
        }
    ];

    const filteredRows = useMemo(() => {
        const hasFilters = Object.values(filters).some(Boolean);
        if (!hasFilters) {
            return inspections;
        }

        return inspections.filter((row) =>
            Object.entries(filters).every(([key, value]) => {
                if (!value) return true;
                const fieldValue = row[key];
                if (typeof fieldValue === "string") {
                    return fieldValue.toLowerCase().includes(String(value).toLowerCase());
                }
                return fieldValue === value;
            })
        );
    }, [filters, inspections]);

    const tableData = useMemo(() => {
        const page_length = 10; // force 10 rows per page
        const start = (currentPage - 1) * page_length;
        const end = start + page_length;
    
        return filteredRows.slice(start, end).map((row, index) => ({
            ...row,
            siNo: index + 1 + start
        }));
    }, [filteredRows, currentPage]);
    

    const handleView = (id) => {
        navigate("/master/quality-inspection/view-quality-inspection", { state: { inspectionId: id } });
    };

    const handleEdit = (id) => {
        navigate("/master/quality-inspection/edit-quality-inspection", { state: { inspectionId: id } });
    };

    const handleDelete = (id) => {
        console.log("Delete Quality Inspection", id);
    };

    const handleSaveColumns = (selectedKeys) => {
        setColumnsConfig((prev) =>
            prev.map((column) => ({
                ...column,
                visible: selectedKeys.includes(column.accessor)
            }))
        );
    };

    const visibleColumns = useMemo(() => columnsConfig.filter((col) => col.visible), [columnsConfig]);
    const defaultSelectedColumns = useMemo(
        () =>
            columnsConfig
                .filter((col) => col.visible)
                .map((col) => ({
                    fieldname: col.accessor,
                    label: col.name
                })),
        [columnsConfig]
    );

    const exportFields = useMemo(
        () =>
            columnsConfig
                .filter((column) => column.accessor && column.accessor !== "action" && column.accessor !== "siNo")
                .map((column) => column.accessor),
        [columnsConfig]
    );

    const activeFilterCount = useMemo(
        () => Object.values(filters).filter((value) => value !== undefined && value !== "").length,
        [filters]
    );

    const actionButtons = [
        {
            className: "createbtnsfilter border-0 d-flex",
            style: { gap: "2px", height: "28px" },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters((prev) => !prev);
                setShowColumns(false);
            }
        },
        {
            className: "btnsecond border-0 d-flex",
            style: { gap: "2px", height: "28px" },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show Columns",
            onClick: () => {
                setShowColumns((prev) => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "btnthird border-0 d-flex",
            style: { gap: "2px", height: "28px" },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExport(true)
        },
        {
            className: "custom-btn-00989 d-flex",
            to: "/master/quality-inspection/create-quality-inspection",
            iconName: "FiPlus",
            style: { gap: "2px", height: "28px" },
            children: "Add Quality Inspection"
            
        }
    ];

    const handleFilterChange = (newFilters) => {
        setCurrentPage(1);
        setFilters(newFilters);
    };

    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: 1 }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Quality Inspection" },
                    { label: "Quality Inspection List", style: { color: "#4b002b" } }
                ]}
                actionButtons={actionButtons}
            >
                {showFilters && (
                    <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                )}

                {showColumns && (
                    <ConfigureColumnsNew
                        show={showColumns}
                        onClose={() => setShowColumns(false)}
                        onSave={handleSaveColumns}
                        docType="Quality Inspection"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map((col) => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo", "action"]}
                    />
                )}

                <Table columns={visibleColumns} data={tableData} loading={false} />

                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={10}
                    totalRecords={filteredRows.length}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />

                {showExport && (
                    <ExportCSV
                        doctype="Quality Inspection"
                        fieldsData={exportFields}
                        onClose={() => setShowExport(false)}
                    />
                )}
            </ListLayout>
        </div>
    );
};

export default Maincontent;